import { localeMap } from '../common';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

type FooterProps = {
    bgColor?: string;
    titleColor?: string;
    descColor?: string;
    borderTopColor?: string;
    boxStyle?: Record<string, string | number>;
};

export default function IRAFooter({ bgColor, titleColor, descColor, borderTopColor = '#444', boxStyle }: FooterProps) {
    const { useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const langItem = localeMap[locale as keyof typeof localeMap] || localeMap.us;

    return (
        <div className={styles.IRAFooter}>
            <div className={`${isMobile ? 'mobile-footer' : 'pc-footer'}`} style={{ backgroundColor: bgColor || '#000' }}>
                <div className="ira-footer" style={{ ...boxStyle, borderTop: `1px solid ${borderTopColor}` }}>
                    <div className="title" style={{ color: titleColor || '#D7D7D7' }}>
                        {langItem.footerTitle}
                    </div>
                    <div className="desc" style={{ color: descColor || '#757575' }}>
                        {langItem.desc}
                    </div>
                    <div className="desc date-text" style={{ color: descColor || '#757575' }}>
                        {langItem.dateText}
                    </div>
                </div>
            </div>
        </div>
    );
}
